// extracted by mini-css-extract-plugin
export default {"formSelectLabel":"FormSelect_formSelectLabel__GBXcv","formSelect":"FormSelect_formSelect__ovLu8","formSelectErrorText":"FormSelect_formSelectErrorText__NbcbH"};